import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
function ts(d) { if(!d) return 'Never'; const m=Math.floor((Date.now()-new Date(d))/60000); return m<60?`${m}m ago`:m<1440?`${Math.floor(m/60)}h ago`:`${Math.floor(m/1440)}d ago`; }
const SCOPES_ALL = ['read','write','devices','patches','compliance','reports','webhooks','admin'];

export default function ApiKeys({ user }) {
  const [keys,   setKeys]   = useState([]);
  const [loading,setLoading]= useState(true);
  const [msg,    setMsg]    = useState({ text:'', type:'' });
  const [showForm,setShowForm]= useState(false);
  const [form,   setForm]   = useState({ name:'', description:'', scopes:['read'], expiresAt:'' });
  const [saving, setSaving] = useState(false);
  const [newKey, setNewKey] = useState(null); // shown once after creation

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),5000); }
  const load = useCallback(async () => {
    try { const r = await axios.get('/api/api-keys', auth()); setKeys(r.data); } catch(e) { flash('Failed','error'); } finally { setLoading(false); }
  },[]);
  useEffect(()=>{ load(); },[load]);

  async function create(e) {
    e.preventDefault(); setSaving(true);
    try {
      const r = await axios.post('/api/api-keys', form, auth());
      setNewKey(r.data.rawKey);
      flash('API key created — save it now, it will not be shown again'); setShowForm(false);
      setForm({ name:'', description:'', scopes:['read'], expiresAt:'' }); load();
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); } finally { setSaving(false); }
  }

  async function revoke(id) {
    if(!window.confirm('Revoke this API key? It will stop working immediately.'))return;
    try { await axios.delete(`/api/api-keys/${id}`, auth()); flash('Key revoked'); load(); }
    catch(e) { flash('Failed','error'); }
  }

  function toggleScope(s) { setForm(f=>({ ...f, scopes: f.scopes.includes(s) ? f.scopes.filter(x=>x!==s) : [...f.scopes,s] })); }

  const SCOPE_COLOR = { read:'#16a34a', write:'#d97706', admin:'#dc2626', devices:'#1d4ed8', patches:'#7c3aed', compliance:'#0891b2', reports:'#64748b', webhooks:'#db2777' };

  return (
    <div style={{padding:24}}>
      {msg.text&&<div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}

      {newKey&&(
        <div style={{background:'#0f172a',borderRadius:12,padding:20,marginBottom:20}}>
          <div style={{color:'#fbbf24',fontWeight:700,marginBottom:8}}>⚠ Save this API key — it will not be shown again</div>
          <div style={{fontFamily:'monospace',fontSize:14,color:'#e2e8f0',background:'#1e293b',padding:'12px 16px',borderRadius:8,marginBottom:10,wordBreak:'break-all'}}>{newKey}</div>
          <div style={{display:'flex',gap:8}}>
            <button onClick={()=>navigator.clipboard?.writeText(newKey).then(()=>flash('Copied!'))} style={{padding:'7px 16px',background:'#1e40af',color:'#fff',border:'none',borderRadius:6,fontWeight:600,cursor:'pointer',fontSize:12}}>📋 Copy</button>
            <button onClick={()=>setNewKey(null)} style={{padding:'7px 16px',background:'#475569',color:'#fff',border:'none',borderRadius:6,fontWeight:600,cursor:'pointer',fontSize:12}}>✕ Dismiss</button>
          </div>
        </div>
      )}

      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div><h2 style={{margin:0,fontSize:20,fontWeight:700}}>API Keys</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Generate scoped API keys for SIEM integrations, custom scripts, and third-party tools</p></div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>+ Generate Key</button>
      </div>

      {/* Integration examples */}
      <div style={{background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:10,padding:14,marginBottom:20,fontSize:12,color:'#475569'}}>
        <span style={{fontWeight:700,color:'#374151'}}>Usage: </span>
        <code>curl -H "x-api-key: psk_..." https://patchsphere.covasant.com/api/agents</code>
        <span style={{marginLeft:16,fontWeight:700,color:'#374151'}}>Python: </span>
        <code>requests.get(url, headers={'{'}"x-api-key": key{'}'})</code>
      </div>

      {loading ? <div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>Loading...</div> :
      keys.length===0 ? <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>🔑</div><div style={{fontWeight:600,marginTop:12}}>No API keys yet</div></div> : (
        <table style={{width:'100%',borderCollapse:'collapse',background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,overflow:'hidden'}}>
          <thead><tr style={{background:'#f8fafc'}}>
            {['Name','Prefix','Scopes','Last Used','Uses','Expires',''].map(h=><th key={h} style={{padding:'10px 14px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748b',borderBottom:'1px solid #f1f5f9'}}>{h}</th>)}
          </tr></thead>
          <tbody>
            {keys.map(k=>(
              <tr key={k.id} style={{borderBottom:'1px solid #f8fafc',opacity:k.active?1:0.5}}>
                <td style={{padding:'10px 14px'}}>
                  <div style={{fontWeight:600,fontSize:13}}>{k.name}</div>
                  {k.description&&<div style={{fontSize:11,color:'#64748b'}}>{k.description}</div>}
                </td>
                <td style={{padding:'10px 14px',fontFamily:'monospace',fontSize:12,color:'#475569'}}>{k.keyPrefix}...</td>
                <td style={{padding:'10px 14px'}}><div style={{display:'flex',gap:4,flexWrap:'wrap'}}>{(k.scopes||[]).map(s=><span key={s} style={{background:`${SCOPE_COLOR[s]||'#64748b'}15`,color:SCOPE_COLOR[s]||'#64748b',borderRadius:4,padding:'1px 6px',fontSize:10,fontWeight:700}}>{s}</span>)}</div></td>
                <td style={{padding:'10px 14px',fontSize:12,color:'#64748b'}}>{ts(k.lastUsedAt)}</td>
                <td style={{padding:'10px 14px',fontSize:12,color:'#64748b'}}>{k.useCount||0}</td>
                <td style={{padding:'10px 14px',fontSize:12,color:k.expiresAt&&new Date(k.expiresAt)<new Date()?'#dc2626':'#64748b'}}>{k.expiresAt?new Date(k.expiresAt).toLocaleDateString():'Never'}</td>
                <td style={{padding:'10px 14px'}}>
                  {k.active ? <button onClick={()=>revoke(k.id)} style={{background:'#fee2e2',border:'none',borderRadius:6,padding:'5px 10px',fontSize:11,cursor:'pointer',color:'#dc2626',fontWeight:600}}>Revoke</button>
                  : <span style={{background:'#f1f5f9',borderRadius:5,padding:'3px 8px',fontSize:10,color:'#94a3b8',fontWeight:700}}>REVOKED</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showForm&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:480,maxWidth:'95vw'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>Generate API Key</h3>
            <form onSubmit={create}>
              {[['Name*','name','e.g. Splunk Integration'],['Description','description','What this key is used for']].map(([l,k,ph])=>(
                <div key={k} style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                  <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={l.includes('*')} placeholder={ph} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              ))}
              <div style={{marginBottom:14}}>
                <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:8}}>Scopes</label>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {SCOPES_ALL.map(s=>(
                    <button key={s} type="button" onClick={()=>toggleScope(s)} style={{padding:'4px 10px',borderRadius:5,border:'1px solid',fontSize:12,cursor:'pointer',fontWeight:600,background:form.scopes.includes(s)?SCOPE_COLOR[s]||'#1e40af':'#f1f5f9',color:form.scopes.includes(s)?'#fff':'#475569',borderColor:form.scopes.includes(s)?SCOPE_COLOR[s]||'#1e40af':'#e2e8f0'}}>{s}</button>
                  ))}
                </div>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Expires (blank=never)</label>
                <input type="date" value={form.expiresAt} onChange={e=>setForm({...form,expiresAt:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Generating...':'Generate Key'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
